const getMimeTypeByExt = (type: string) => {
  switch (type) {
    case "pdf":
      return "application/pdf";
    case "jpeg":
    case "jpg":
      return "image/jpeg";
    case "png":
      return "image/png";
  }
  return "application/pdf";
};

export const printFile = (blob: Blob, type: string) => {
  const blobContent = new Blob([blob], { type: getMimeTypeByExt(type) });
  const blobURL = URL.createObjectURL(blobContent);

  const iframe = document.createElement("iframe");
  document.body.appendChild(iframe);

  iframe.style.display = "none";
  iframe.src = blobURL;
  iframe.onload = function () {
    setTimeout(function () {
      iframe.focus();
      iframe.contentWindow?.print();
    }, 1);
  };
};
